import axios from "axios";

const url = process.env.REACT_APP_API_URL_TRANSACTION
const contentType = 'application/json'
const urlIntegrasi = process.env.REACT_APP_API_URL_INTEGRASI

export default class TransaksiService {
    listPnbpBilling(noBill, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (noBill != null) {
            param += '&noBill=' + noBill
        }
        return axios.get(url + '/pnbp-billing?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPnbpBillingById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/pnbp-billing/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePnbpBillingById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pnbp-billing/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPnbpBilling(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pnbp-billing', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPnbpBilling(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pnbp-billing', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPnbpBillingDtl(idBill, noPnbp, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (idBill != null) {
            param += '&idBill=' + idBill
        }
        if (noPnbp != null) {
            param += '&noPnbp=' + noPnbp
        }
        return axios.get(url + '/pnbp-billing-dtl?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPnbpBillingDtlById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/pnbp-billing-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePnbpBillingDtlById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pnbp-billing-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPnbpBillingDtl(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pnbp-billing-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPnbpBillingDtl(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pnbp-billing-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listHcMutu(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/hc-mutu?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHcMutuById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hc-mutu-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    addHcMutu(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hc-mutu', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHcMutu(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hc-mutu', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteHcMutu(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hc-mutu', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    listHcMutuDetail(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/hc-mutu-detail?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHcMutuDetailById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hc-mutu-detail-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    addHcMutuDetail(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hc-mutu-detail', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHcMutuDetail(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hc-mutu-detail', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteHcMutuDetail(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hc-mutu-detail', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    listHasilEvPermohonan(idEvp, nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (idEvp != null) {
            param += '&idEvp=' + idEvp
        }
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/hasil-ev-permohonan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHasilEvPermohonanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteHasilEvPermohonanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHasilEvPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-ev-permohonan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHasilEvPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hasil-ev-permohonan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listHasilOrganoleptik(idOrgano, noHasilOrgano, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (idOrgano != null) {
            param += '&idOrgano=' + idOrgano
        }
        if (noHasilOrgano != null) {
            param += '&noHasilOrgano=' + noHasilOrgano
        }
        return axios.get(url + '/hasil-organo?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHasilOrganoById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-organo/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteHasilOrganoById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-organo/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHasilOrgano(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-organo', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHasilOrgano(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hasil-organo', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listHasilOrganoleptikDetil(idHasilOrgano, nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (idHasilOrgano != null) {
            param += '&idHasilOrgano=' + idHasilOrgano
        }
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/hasil-organo-dtl?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHasilOrganoDetilById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-organo-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteHasilOrganoDetilById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-organo-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHasilOrganoDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-organo-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHasilOrganoDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hasil-organo-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listHasilVerLapangan(idVlap, nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (idVlap != null) {
            param += '&idVLap=' + idVlap
        }
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/hasil-verif-lapangan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHasilVerLapanganById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-verif-lapangan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteHasilVerLapanganById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-verif-lapangan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHasilVerLapangan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-verif-lapangan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHasilVerLapangan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hasil-verif-lapangan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listKurs(mataUang, tglKurs, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (mataUang != null) {
            param += '&mataUang=' + mataUang
        }
        if (tglKurs != null) {
            param += '&tglKurs=' + tglKurs
        }
        return axios.get(url + '/kurs?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKursById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kurs/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteKursById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kurs/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKurs(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kurs', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKurs(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kurs', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPnbp(nomorAju, noPnbp, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (noPnbp != null) {
            param += '&noPnbp=' + noPnbp
        }
        return axios.get(url + '/pnbp?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPnbpByAjuNoPnbp(nomorAju, noPnbp) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        return axios.get(url + '/pnbp-by-aju?nomorAju=' + nomorAju + '&noPnbp=' + noPnbp, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPnbpById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/pnbp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePnbpById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pnbp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPnbp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pnbp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPnbp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pnbp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPnbpDetil(idPnbp, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (idPnbp != null) {
            param += '&idPnbp=' + idPnbp
        }
        return axios.get(url + '/pnbp-dtl?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPnbpDetilById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/pnbp-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePnbpDetilById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pnbp-dtl/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPnbpDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pnbp-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPnbpDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pnbp-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpm(nomorAju, npwp, status, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (npwp != null) {
            param += '&npwpTrader=' + npwp
        }
        if (status != null) {
            param += '&status=' + status
        }
        return axios.get(url + '/ppk?page=' + page + '&size=' + size + '&sort=tanggalAju,desc&sort=nomorAju,desc' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPpmPerUpt(nomorAju, npwp, kdUpt, status, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (npwp !== null) {
            param += '&npwpTrader=' + npwp
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (status !== null) {
            param += '&status=' + status
        }
        return axios.get(url + '/ppk-upt?page=' + page + '&size=' + size + '&sort=tanggalAju,desc' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-header?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePpmById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-header?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPpm(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-header', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpm(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-header', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmContainer(nomorAju, nomor, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nomor != null) {
            param += '&nomor=' + nomor
        }
        return axios.get(url + '/ppk-container?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmContainerById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-container-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePpmContainerById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-container', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addPpmContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmDetil(nomorAju, idIkan, kodeHs, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (idIkan != null) {
            param += '&idIkan=' + idIkan
        }
        if (kodeHs != null) {
            param += '&kodeHs=' + kodeHs
        }
        return axios.get(url + '/ppk-dtl?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmDetilById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-dtl-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePpmDetilById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-dtl', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addPpmDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-dtl', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmDok(nomorAju, nomor, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nomor != null) {
            param += '&nomor=' + nomor
        }
        return axios.get(url + '/ppk-dok?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmDokById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-dok-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    getPpmDokByAjuKodeDok(nomorAju, kodeDokumen) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-dok-by-aju-kodedok?nomorAju=' + nomorAju + '&kodeDokumen=' + kodeDokumen, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePpmDokById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-dok', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addPpmDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-dok', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-dok', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmKemasan(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/ppk-kemasan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmKemasanById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-kemasan-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePpmKemasanById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-kemasan', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addPpmKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmMutu(upiNama, upiRegNo, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (upiNama != null) {
            param += '&upiNama=' + upiNama
        }
        if (upiRegNo != null) {
            param += '&upiRegNo=' + upiRegNo
        }
        return axios.get(url + '/ppk-mutu?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmMutuById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-mutu-by-id?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePpmMutuById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-mutu?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPpmMutu(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-mutu', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmMutu(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-mutu', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmMutuArea(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-mutu-area?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmMutuAreaById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-mutu-area-by-id?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePpmMutuAreaById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-mutu-area?nomorAju=' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPpmMutuArea(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-mutu-area', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmMutuArea(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-mutu-area', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPpmMutuProd(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        return axios.get(url + '/ppk-mutu-prod?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPpmMutuProdAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppk-mutu-prod-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPpmMutuProdById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-mutu-prod-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePpmMutuProdById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppk-mutu-prod', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addPpmMutuProd(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppk-mutu-prod', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPpmMutuProd(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ppk-mutu-prod', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listTugasEvPermohonan(nomorAju, noTugas, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (noTugas != null) {
            param += '&noTugas=' + noTugas
        }
        return axios.get(url + '/tugas-ev-permohonan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTugasEvPermohonanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tugas-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteTugasEvPermohonanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/tugas-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTugasEvPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/tugas-ev-permohonan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTugasEvPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/tugas-ev-permohonan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listTugasOrgano(nomorAju, noTugas, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (noTugas != null) {
            param += '&noTugas=' + noTugas
        }
        return axios.get(url + '/tugas-organo?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTugasOrganoById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tugas-organo/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteTugasOrganoById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/tugas-organo/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTugasOrgano(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/tugas-organo', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTugasOrgano(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/tugas-organo', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listTugasVerLapangan(nomorAju, noTugas, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (noTugas != null) {
            param += '&noTugas=' + noTugas
        }
        return axios.get(url + '/tugas-ver-lapangan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTugasVerLapanganById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tugas-ver-lapangan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteTugasVerLapanganById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/tugas-ver-lapangan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTugasVerLapangan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/tugas-ver-lapangan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTugasVerLapangan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/tugas-ver-lapangan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPenugasan(nomorAju, idDisposisi, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju != null) {
            param += '&nomorAju=' + nomorAju
        }
        if (idDisposisi !== null) {
            param += '&idDisposisi=' + idDisposisi
        }
        return axios.get(url + '/penugasan?page=' + page + '&size=' + size + param + '&sort=idProses&order=asc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPenugasanAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan-all?nomorAju='+nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPenugasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePenugasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/penugasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPenugasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/penugasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPenugasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/penugasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listPenugasanDetil(nomorAju, noTugas) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan-detil?nomorAju=' + nomorAju + '&noTugas=' + noTugas, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPenugasanDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/penugasan-detil', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    sendSmkhpToInsw(nomorAju) {
        return axios.get(urlIntegrasi + '/send-smkhp-to-insw/' + nomorAju)
    }

    nextSeri(tableName, nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/next-seri?tableName=' + tableName + '&nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPpmDetilAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += 'nomorAju=' + nomorAju
        }
        return axios.get(url + '/ppk-dtl-all?' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPpmKemasanAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += 'nomorAju=' + nomorAju
        }
        return axios.get(url + '/ppk-kemasan-all?' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPpmContainerAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += 'nomorAju=' + nomorAju
        }
        return axios.get(url + '/ppk-container-all?' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTotalJumlahKomoditiPerSatuan(nomorAju){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nomorAju != null) {
            param += 'nomorAju=' + nomorAju
        }
        return axios.get(url + '/total-jumlah-per-satuan?' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }
}